import React, { useState,useEffect } from 'react'
import { useLocation, useNavigate } from "react-router-dom";

import { Button, Input, Select, Table ,Checkbox ,} from "antd";
import "aos/dist/aos.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Option } from 'antd/es/mentions';
import { GetRateSheetApprovalList, GetRateSheetByOrderNumber ,GetRateSheetBulkApproval, UpdateOrderEntrySecond, GetRateSheetRateUpdate} from '../../AllAPI/SalesAPI/SalesApi';
import DataTable from 'react-data-table-component';

const RateApproval = () => {

  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  };
 const [errors, setErrors] = useState({
       selectedId:"",

      });
    
  const goodTypesOptions = [
    { value: '1', label: 'F.T' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]
  const [allOrders, setAllOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [approvedItems, setApprovedItems] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const[selectedId , setSelectedId]=useState("");
  const[orderPass , setOrderPass]=useState(false);

   const [pageSize, setPageSize] = useState(10);
        const [filteredData, setFilteredData] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [totalEntries, setTotalEntries] = useState(0);
        const [isBulkSelecting, setIsBulkSelecting] = useState(false);
//=======================To Again call the dropdown api after navigation ===================================================================
  const location = useLocation();
  const navigate = useNavigate();

  const fetchRateSheetData = async () => {
    try {
      const response = await axios.get(GetRateSheetApprovalList, commonHeaders);
      setAllOrders(response.data); // Update dropdown list
    } catch (error) {
      console.error("Error fetching Rate Sheet data:", error);
      toast.error("Error fetching Rate Sheet data:");
    }
  };

  useEffect(() => {
    fetchRateSheetData(); // Always fetch on first mount

    if (location.state?.refresh) {
      console.log("Refetching after return from approval page");
      fetchRateSheetData();

      // Remove refresh flag from location.state
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);
//===========================================================================================================================================
  //  //======Search data from table===============
  //     const handleSearch = (value) => {
  //     const searchValue = value.toLowerCase();
  
  //     const filtered = orderItems.filter((item) =>
  //       Object.values(item).some((val) =>
  //         String(val ?? "").toLowerCase().includes(searchValue)
  //       )
  //     );

  //     setFilteredData(filtered);
  //     setTotalEntries(filtered.length); // Update total entries count after filtering
  //     setCurrentPage(1);
  //   };
  // //==========Pagination=======================
  // const handlePageSizeChange = (value) => {
  //   setPageSize(value);
  // };
  //      // ==============Get  data================
  //      let isRateApprovalFetched = false;
  // useEffect(() => {
  //   if (isRateApprovalFetched) return;

  //  // fetchOrders();
  //   fetchRateSheetData();
  //   isRateApprovalFetched = true;
  // }, []);
  // const fetchRateSheetData = async () => {
  //   try {
  //    // const response = await axios.get("http://192.168.29.1getRateSheetApprovalList16:8182/sales/RateSheetApproval/getRateSheetApprovalList",commonHeaders);
  //    const response = await axios.get(GetRateSheetApprovalList,commonHeaders);
  //     setAllOrders(response.data); // assuming the API returns an array
  //   } catch (error) {
  //     console.error("Error fetching Rate Sheet data:", error);
  //     toast.error("Error fetching Rate Sheet data:");
  //   }
  // };


  // const handleOrderSelect = async (orderId) => {
  //     const order = allOrders.find((o) => o.id === orderId);
  //   setSelectedOrder(order); 
  // };

  // const toggleItemSelection = (itemId, isChecked) => {
  //   setApprovedItems((prev) => {
  //     const updated = new Set(prev);
  //     isChecked ? updated.add(itemId) : updated.delete(itemId);
  
  //     setIsBulkSelecting(updated.size > 1);
  //     return updated;
  //   });
  // };
   
  // const handleItemApproval = async (itemId , currentrateStatus) => {
  //   if (approvedItems.has(itemId)) {
  //     const newrateStatus = currentrateStatus === 0 ? 1 : (currentrateStatus === 1 ? 2 : 1);
  //           await approveItems([itemId],newrateStatus); // Wrap single ID in array
  //   } else {
  //     toast.warn("Please select the checkbox before approving.");
  //   }
  // };
  
 
  
//   const handleBulkApprove = async () => {
//     const idsToApprove = Array.from(approvedItems);
  
//     if (idsToApprove.length > 0) {
//       const selectedStatuses = orderItems
//         .filter((item) => approvedItems.has(item.id))
//         .map((item) => item.rateStatus);
  
//         const allApproved = selectedStatuses.every((status) => status === 1);
//         const newStatus = allApproved ? 2 : 1;

  
//       await approveItems(idsToApprove, newStatus);
  
//       setApprovedItems(new Set());
//       setSelectAll(false);
//       setIsBulkSelecting(false);
//     } else {
//       toast.warn("No items selected for bulk action.");
//     }
//   };
//   //========================================= For Bulk Approval /Rejection Button =====================================
//   const selectedStatuses = orderItems
//   .filter((item) => approvedItems.has(item.id))
//   .map((item) => item.rateStatus);

// const bulkActionType = selectedStatuses.length > 0 && selectedStatuses.every((status) => status === 1)
//   ? "reject"
//   : "approve";

// const buttonText = bulkActionType === "approve" ? "Approve Selected Items" : "Reject Selected Items";
// const buttonColor = bulkActionType === "approve" ? "#28a745" : "#dc3545";
// //=======================================================================================
  
//   const approveItems = async (orderNumberIds ,rateStatus) => {
//     const requestBody ={
//         id : orderNumberIds,
//         rateStatus:1,
//     }
//     // const requestBody = orderNumberIds.map((orderNumber) => ({
//     //   finalOrderNumber: orderNumber,  
//     //   orderNumberId: selectedId,     
//     //   itemApproval: 1 ,               
//     // }));

//     try {
//       const response = await axios.post(
//        `${GetRateSheetBulkApproval}?ids=${orderNumberIds}&rateStatus=${rateStatus}`,null,commonHeaders
//       );
  
//       if (response.data === "OK") {
//         const action = rateStatus === 1 ? "Approved" : "Rejected";
//         toast.success(`${action} successfully!`);        
//         handleSubmitOrder(selectedId);
//         // setSelectedOrder(null);
//         // setOrderItems([]);
//         // setApprovedItems(new Set());
//         // fetchRateSheetData();
//       } else if (response.data === "alreadyexisted") {
//         toast.warn("Item(s) already approved!");
//       }
//     } catch (error) {
//       console.error("Error during approval:", error);
//       toast.error("Error occurred while approving item(s)");
//     }
//   };
   
  

  // const handleSelectAll = (e) => {
  //   const checked = e.target.checked;
  //   setSelectAll(checked);
  //   setIsBulkSelecting(checked); // update bulk selecting state
  //   if (checked) {
  //     const allIds = orderItems.map((item) => item.id);
  //     setApprovedItems(new Set(allIds));
  //   } else {
  //     setApprovedItems(new Set());
  //   }
  // };
  // const handleSelectAll = (e) => {
  //   const checked = e.target.checked;
  //   setSelectAll(checked);
  //   setIsBulkSelecting(checked);
  
  //   if (checked) {
  //     const allIds = orderItems.map((item) => item.id);
  //     setApprovedItems(new Set(allIds));
  
  //     // Prepare editedRates for each item
  //     const updatedRates = {};
  //     orderItems.forEach((item) => {
  //       updatedRates[item.finalOrderNumber] = {
  //         basicOrderRate: item.basicOrderRate || 0,
  //         packingRate: item.packingRate || 0,
  //         premium: item.premium || 0,
  //       };
  //     });
  //     setEditedRates(updatedRates);
  //   } else {
  //     setApprovedItems(new Set());
  //     setEditedRates({}); // clear rates if deselecting all
  //   }
  // };
  // const [editedRates, setEditedRates] = useState({});

  // const handleRateChange = (orderNumber, field, value) => {
  //   setEditedRates((prev) => {
  //     const updated = {
  //       ...prev,
  //       [orderNumber]: {
  //         ...prev[orderNumber],
  //         [field]: parseFloat(value) || 0,
  //       },
  //     };
  //     return updated;
  //   });
  // };
  // const handleRateChange = (orderId, field, value) => {
  //   setEditedRates((prevRates) => {
  //     const prevEntry = prevRates[orderId] || {};
  
  //     return {
  //       ...prevRates,
  //       [orderId]: {
  //         ...prevEntry, // keep existing fields (e.g., premium, packingRate)
  //         [field]: value, // update only the changed field
  //       },
  //     };
  //   });
  // };
  // const handleRateChange = (orderId, field, value) => {
  //   setEditedRates((prevRates) => {
  //     const prevEntry = prevRates[orderId];
  
  //     // If this is the first time we're editing this row
  //     if (!prevEntry) {
  //       const originalRow = orderItems.find((row) => row.finalOrderNumber === orderId);
  //       return {
  //         ...prevRates,
  //         [orderId]: {
  //           basicOrderRate: originalRow?.basicOrderRate ?? "",
  //           premium: originalRow?.premium ?? "",
  //           packingRate: originalRow?.packingRate ?? "",
  //           [field]: value, // override the changed field with new value
  //         },
  //       };
  //     }
  
  //     // If already edited before, just update the changed field
  //     return {
  //       ...prevRates,
  //       [orderId]: {
  //         ...prevEntry,
  //         [field]: value,
  //       },
  //     };
  //   });
  // };
  
  
  // const getCalculatedRate = (record) => {
  //   if (!record || !record.finalOrderNumber) return "0.00"; // fallback if record is null or missing keys
  
  //   const edited = editedRates[record.finalOrderNumber] || {};
  //   const basic = Number(edited.basicOrderRate ?? record.basicOrderRate ?? 0);
  //   const premium = Number(edited.premium ?? record.premium ?? 0);
  //   const packing = Number(edited.packingRate ?? record.packingRate ?? 0);
  
  //   return (basic + premium + packing).toFixed(2);
  // };
  
  // const updateRates = async (id) => {
  //   const selectedRateUpdates = [];

  //   approvedItems.forEach((id) => {
  //     const record = orderItems.find((item) => item.id === id);
  //     const edited = editedRates[record.finalOrderNumber];
  
  //     if (!record || !edited) return;
  
  //     selectedRateUpdates.push({
  //       id: record.id,
  //       basicOrderRate: parseFloat(edited.basicOrderRate),
  //       packingRate: parseFloat(edited.packingRate),
  //       premium: parseFloat(edited.premium),
  //     });
  //   });
  
  //   // const requestBody = {
  //   //   id,
  //   //   basicOrderRate: parseFloat(edited.basicOrderRate),
  //   //   packingRate: parseFloat(edited.packingRate),
  //   //   premium: parseFloat(edited.premium),
  //   // };
  
  //   try {
  //     const response = await axios.put(
  //       GetRateSheetRateUpdate,
  //       selectedRateUpdates,commonHeaders
  //     );
  
  //     if (response.data === "UPDATED") {
  //       toast.success("Rates updated successfully!");
  //       handleSubmitOrder(selectedId);

  //       return true;
  //     } else {
  //       toast.warn("Unexpected response: " + response.data);
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("Rate update failed:", error);
  //     toast.error("Rate update failed.");
  //     return false;
  //   }
  // };
  
  
  
//   const columns = [
// {
//   title: "Sr. No",
//     key: "serial",
//     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
//   },
//     {
//       title: "Entry Date",
//       dataIndex: "poDate",
//       key: "poDate",
//     },
//     {
//       title: "Item Name",
//       dataIndex: "dieName",
//       key: "dieName",
//     },
//     {
//       title: "Alloy",
//       dataIndex: "alloyname",
//       key: "alloyname",
//     },
//     {
//       title: "Temper",
//       dataIndex: "temperName",
//       key: "temperName",
//     },
//     {
//       title: "Wt. Range",
//       dataIndex: "weightRange",
//       key: "weightRange",
//     },
//     {
//       title: "Length",
//       dataIndex: "length",
//       key: "length",
//     },
//     {
//       title: "Pcs",
//       dataIndex: "pcs",
//       key: "pcs",
//     },
//     {
//       title: "Quantity (Kgs.)",
//       dataIndex: "qty",
//       key: "qty",
//     },
//     {
//       title: "Basic Rate",
//       dataIndex: "basicOrderRate",
//       key: "basicOrderRate",
//     },
//     {
//       title: "Premium",
//       dataIndex: "premium",
//       key: "premium",
//     },
//     {
//       title: "Packaging Rate",
//       dataIndex: "packingRate",
//       key: "packingRate",
//     },
//     {
//       title: "Basic Rate (New)",
//       key :"basicOrderRateNew",
//       dataIndex : "basicOrderRateNew",
//       render: (_, record) => (
//         <Input
//           type="number"
//           style={{ width: 90}}
//           value={
//             editedRates[record.finalOrderNumber]?.basicOrderRate !== undefined
//       ? editedRates[record.finalOrderNumber].basicOrderRate
//       : record.basicOrderRate ?? ""
//           }
//           onChange={(e) =>
//             handleRateChange(
//               record.finalOrderNumber,
//               "basicOrderRate",
//               e.target.value
//             )
//           }
//         />
//       ),
//     },
//     {
//       title: "Premium (New)",
//       key: "premiumNew",
//       render: (_, record) => (
//         <Input
//           type="number"
//           style={{ width: 90 }}

//           value={
//             editedRates[record.finalOrderNumber]?.premium !== undefined
//           ? editedRates[record.finalOrderNumber].premium
//           : record.premium ?? ""
//           }
//           onChange={(e) =>
//             handleRateChange(
//               record.finalOrderNumber,
//               "premium",
//               e.target.value
//             )
//           }
//         />
//       ),
//     },
//     {
//       title: "Packaging Rate (New)",
//       key: "packingRateNew",
//       render: (_, record) => (
//         <Input
//           type="number"
//           style={{ width: 90 }}

//           value={
//             editedRates[record.finalOrderNumber]?.packingRate !== undefined
//           ? editedRates[record.finalOrderNumber].packingRate
//           : record.packingRate ?? ""
//           }
//           onChange={(e) =>
//             handleRateChange(
//               record.finalOrderNumber,
//               "packingRate",
//               e.target.value
//             )
//           }
//         />
//       ),
//     },
//       {
//         title: "Final Rate (New)",
//         key: "finalRateNew",
//         render: (_, record) => (
//           <span>{getCalculatedRate(record)}</span>
//         ),
//       },
//     {
//       title: "Total Rate",
//       dataIndex: "totalRate",
//       key: "totalRate",
//     },
//     {
//       title: "Item Approval",
//       dataIndex: "rateStatus",
//       key: "rateStatus",
//       render: (rateStatus) => {
//         if (rateStatus === 1) {
//           return "Approved";
//         } else if (rateStatus === 2) {
//           return "Rejected";
//         } else {
//           return "Pending"; // For rateStatus === 0
//         }
//       },
//     },
//     {
//       title: (
//         <span>
//           Select All <Checkbox checked={selectAll} onChange={handleSelectAll} />
//         </span>
//       ),
//       key: "select",
//       render: (_, record) => (
//         <Checkbox
//      checked={approvedItems.has(record.id)}
//       onChange={(e) => toggleItemSelection(record.id, e.target.checked)}

//         />
//       ),
//     },
//     {
//       title: "Approve",
//       key: "approve",
//       render: (_, record) => (
//         <div style={{ display: "flex", gap: "8px" }}>
//         <Button
//           type="primary"
//           style={{ backgroundColor: "#28a745" }}
//           onClick={() => updateRates(record.id)}
//         >
//           Update Rate
//         </Button>
//         <Button
//   style={{
//     backgroundColor: record.rateStatus === 1 ? "#dc3545" : "#007bff", // Blue for Approved, Red for Rejected
//     color: "#fff",
//   }}         onClick={() =>
//         handleItemApproval(record.id , record.rateStatus)
//       }
//         >
//         {record.rateStatus === 1 ? "Reject" : "Approve"}
       
//         </Button></div>
//       ),
//     },
//   ];
  

  
//    const components = {
//         header: {
//           cell: ({ children, ...restProps }) => (
//             <th
//               {...restProps}
//               style={{
//                 backgroundColor: "#023e7d",
//                 color: "#fff",
//                 padding: "10px",
//                fontSize: "14px",
//                 borderRadius: "0px",
//               }}
//             >
//               {children}
//             </th>
//           ),
//         },
//         body: {
//           row: ({ children, ...restProps }) => (
//             <tr
//               {...restProps}
//               style={{
//                 backgroundColor: "#f0f7fd",
//               }}
//             >
//               {children}
//             </tr>
//           ),
//           cell: ({ children, ...restProps }) => (
//             <td
//               {...restProps}
//               style={{
//                 padding: "8px",
//                 fontSize: "14px"
//               }}
//             >
//               {children}
//             </td>
//           ),
//         },
//       };
// const columns = [
//   {
//     name: "Sr. No.",
//     cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
//     width: "80px",
//   },
//   {
//     // name: " Item Entry Date",
//     name: <div>Item Entry<br />Date</div>,

//     selector: (row) => {
//       const date = row.itemEntryDate;
//       if (!date) return "-";
//       const [year, month, day] = date.split("-");
//       return `${day}/${month}/${year}`;
//     },
    
//     sortable: true,
//   },
//   {
//     // name: "Item Name",
//     name: <div>Item <br />Name</div>,

//     selector: (row) => row.dieName,
//     sortable: true,
//   },
//   {
//     name: "Alloy",
//     selector: (row) => row.alloyname,
//      sortable: true,
//   },
//   {
//     name: "Temper",
//     selector: (row) => row.temperName,
//      sortable: true,
//   },
//   {
//     name: "Wt. Range",
//     selector: (row) => row.weightRange,
//      sortable: true,
//   },
//   {
//     name: "Length",
//     selector: (row) => row.length,
//     sortable: true,
//        cell: row => {
//   const unitOption = goodTypesOptions.find(opt => opt.value === String(row.unit));
//   const unitLabel = unitOption ? `(${unitOption.label})` : "";
//   return `${row.length ?? ''} ${unitLabel}`;
   
// }

//   },
//   //  {
//   //     name: 'Unit',
//   //     selector: (row) => {
//   //       const unitOption = goodTypesOptions.find((opt) => opt.value === String(row.unit));
//   //       return unitOption ? unitOption.label : ''; // e.g., 'MM' or 'Inch'
//   //     },
//   //   },
//   {
//     name: "Pcs",
//     selector: (row) => row.pcs,
//      sortable: true,
//   },
//   {
//     // name: "Quantity (Kgs.)",
//     name: <div>Quantity<br />(Kgs.)</div>,
//     selector: (row) => row.qty,
//     sortable: true,
//   },
//   {
//     name: "Basic Rate",
//     selector: (row) => row.basicOrderRate,
//     sortable: true,
//   },
//   {
//     name: "Premium",
//     selector: (row) => row.premium,
//     sortable: true,
//   },
//   {
//     // name: "Packaging Rate",
//     name: <div>Packing<br />Rate</div>,
//     selector: (row) => row.packingRate,
//     sortable: true,
//   },
//   {
//     // name: "Basic Rate (New)",
//     name: <div>Basic<br />Rate(New)</div>,
// sortable: true,
//     cell: (row) => (
//       <Input
//         type="number"
//         style={{ width: 90 }}
//         value={
//           editedRates[row.finalOrderNumber]?.basicOrderRate !== undefined
//             ? editedRates[row.finalOrderNumber].basicOrderRate
//             : row.basicOrderRate ?? ""
//         }
//         onChange={(e) =>
//           handleRateChange(row.finalOrderNumber, "basicOrderRate", e.target.value)
//         }
//       />
//     ),
//   },
//   {
//     name: "Premium (New)",
//     sortable: true,
//     cell: (row) => (
//       <Input
//         type="number"
//         style={{ width: 90 }}
//         value={
//           editedRates[row.finalOrderNumber]?.premium !== undefined
//             ? editedRates[row.finalOrderNumber].premium
//             : row.premium ?? ""
//         }
//         onChange={(e) =>
//           handleRateChange(row.finalOrderNumber, "premium", e.target.value)
//         }
//       />
//     ),
//   },
//   {
//     // name: "Packaging Rate (New)",
//     name: <div>Packing<br />Rate(New)</div>,
//     sortable: true,
//     cell: (row) => (
//       <Input
//         type="number"
//         style={{ width: 90 }}
//         value={
//           editedRates[row.finalOrderNumber]?.packingRate !== undefined
//             ? editedRates[row.finalOrderNumber].packingRate
//             : row.packingRate ?? ""
//         }
//         onChange={(e) =>
//           handleRateChange(row.finalOrderNumber, "packingRate", e.target.value)
//         }
//       />
//     ),
//   },
//   {
//     // name: "Final Rate (New)",
//     name: <div>Final<br />Rate(New)</div>,
// sortable: true,
//     cell: (row) => <span>{getCalculatedRate(row)}</span>,
//   },
//   {
//     name: "Total Rate",
//     selector: (row) => row.totalRate,
//     sortable: true,
//   },
//   {
//     // name: "Item Approval",
//     name: <div>Item<br />Approval</div>,
// sortable: true,
//     selector: (row) => {
//       if (row.rateStatus === 1) return "Approved";
//       else if (row.rateStatus === 2) return "Rejected";
//       else return "Pending";
//     },
//   },
//   {
//     name: (
//       <span>
//         Select All{" "}
//         <Checkbox checked={selectAll} onChange={handleSelectAll} />
//       </span>
//     ),
//     cell: (row) => (
//       <Checkbox
//         checked={approvedItems.has(row.id)}
//         onChange={(e) => toggleItemSelection(row.id, e.target.checked)}
//       />
//     ),
//   },
//   {
//     name: "Approve",
//     cell: (row) => (
//       <div style={{ display: "flex", gap: "8px" }}>
//         <Button
//           type="primary"
//           style={{ backgroundColor: "#28a745", fontSize: "12px" }}
//           onClick={() => {
//           if (approvedItems.has(row.id)) {
//             updateRates(row.id);
//           } else {
//             toast.warn("Please select the checkbox before updating the rate.");
//           }
//         }}
//         >
//           Update Rate
//         </Button>
//         <Button
//           style={{
//             backgroundColor: row.rateStatus === 1 ? "#dc3545" : "#007bff",
//             color: "#fff",
//             fontSize: "12px",
//           }}
//           onClick={() => handleItemApproval(row.id, row.rateStatus)}
//         >
//           {row.rateStatus === 1 ? "Reject" : "Approve"}
//         </Button>
//       </div>
//     ),
//     width:"200px",
//   },
// ];
// const customStyles = {
//   headRow: {
//     style: {
//       backgroundColor: "#023e7d",
//       color: "#fff",
//             fontSize: '15px',

//     },
//   },
//   rows: {
//     style: {
//       backgroundColor: "#f0f7fd",
//       fontSize: '15px',

//     },
//   },
//   cells: {
//     style: {
//       maxWidth: "200px", // Ensure buttons and long text fit
//       padding: "8px",
//     },
//   },
// };

let isError = false;
      const handleSubmitOrder = async (orderId) => {
        // const order = allOrders.find((o) => o.id  === orderId);
        // setSelectedOrder(order); 
console.log(selectedOrder);
        let isValid = true;
        const errorObj = {};
      
        
        if (!selectedId || (typeof selectedId === 'string' && !selectedId.trim())) {
          isValid = false;
          errorObj.orderId = "Order ID is required *";
        }
      
        setErrors(errorObj); 
        if (!isValid) return;
      
        try {
       
          const response = await axios.get(
            `${GetRateSheetByOrderNumber}?orderNumberId=${orderId}`,
            commonHeaders
          );
      
          const orderDetails = response.data;
      
          if (!orderDetails) {
            toast.error("Failed to fetch order details.");
            return;
          }
      
          console.log("Order details fetched successfully:", orderDetails);
      
          // You can now process or submit the orderDetails further
          if (Array.isArray(orderDetails) && orderDetails.length > 0) {
            setOrderItems(orderDetails);
            setFilteredData(orderDetails);
            setTotalEntries(orderDetails.length);
            const order = allOrders.find((o) => o.id  === orderId);
            setSelectedOrder(order); 
                        localStorage.setItem("selectedOrderData", JSON.stringify({
      orderInfo: order,
     
    }));
            console.log("Order submitted successfully!");
             window.open(`#/ratesheet-details/${orderId}`, "_blank");
          } else {
            toast.warn("No items found for the selected order.");
            setOrderItems([]);  // Clear order items
            setFilteredData([]);  // Clear filtered data (this will reset the table display)
            setTotalEntries(0);  // Reset total entries count
          }
        } catch (error) {
          console.error("Error during order submission:", error);
          toast.error("An error occurred while processing the order.");
        }
      };

  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff',minHeight: '800px'  }}>
          
  <div className="col-12">


    <div className="p-0 m-0">
   <div className="row px-md-5 mt-3 p-2">
      <div className="row p-0 m-0">
        <div className="col-12 col-lg-4"></div>
        <div className="row justify-content-center">
        <div className="col-12 col-lg-6">
          <div className="row p-0 m-0">
            {/* {!selectedOrder && ( */}

              <div className="col-12 py-1">
                <label className="labels">Select Order</label>
                <Select
                  showSearch
                  placeholder="Select an Order"
                  value={selectedId}
                  onChange={(value) => {
                 setSelectedId(value);
                 //handleSubmitOrder(value);

                }}
                 // onChange={handleOrderSelect}
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                >
                  {/* {allOrders.map((order) => (
                    <Option key={order.id} value={order.id}>
      {order.rateStatus === 0 ? (
        <span style={{ color: "red", fontWeight: "bold" }}>🔴</span>
      ) : <span></span>}
      {order.orderNumber} | {order.customerName} | {order.entryDate}  | {order.poNumber}| {order.poDate}  
    </Option>
                  ))} */}
                    {[...allOrders]
                                                .sort((a, b) => {
                                                  if (a.rateStatus === 0 && b.rateStatus !== 0) return -1;
                                               if (a.rateStatus !== 0 && b.rateStatus === 0) return 1;

                                      // Helper: convert 'dd/mm/yyyy' to Date object
                                      const parseDMY = (dateStr) => {
                                        {/* const [day, month, year] = dateStr.split("/");
                                        return new Date(`${year}-${month}-${day}`);
                                      }; */}
                                      if (!dateStr || typeof dateStr !== 'string') return new Date(0); // safe fallback
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  };
                                      const today = new Date();
                                      const aDate = parseDMY(a.entryDate);
                                      const bDate = parseDMY(b.entryDate);
                                    
                                      const isAToday = aDate.toDateString() === today.toDateString();
                                      const isBToday = bDate.toDateString() === today.toDateString();
                                    
                                      if (isAToday && !isBToday) return -1;
                                      if (!isAToday && isBToday) return 1;
                                    
                                      if (a.status === 0 && b.status !== 0) return -1;
                                      if (a.status !== 0 && b.status === 0) return 1;
                                    
                                      // fallback: newest first
                                      return bDate - aDate;
                                    })
                                    
                                        .map((order) => {
                                          const labelText = `${order.orderNumber} | ${order.customerName} | ${order.entryDate} | ${order.poNumber} | ${order.poDate}`;
                                          return (
                                            <Option key={order.id} value={order.id} label={labelText}>
                                            {order.rateStatus === 0 ? (
                          <span style={{ color: "red", fontWeight: "bold" }}>🔴</span>
                        ) : <span></span>}
                                              {labelText}
                                            </Option>
                                          );
                                        })}
                </Select>
                {/* Submit button */}
                <div className="mt-2 text-center">                 
                 <Button
                  type="submit"
                className="SubmitBtn mx-1"
                onClick={()=>{
                  handleSubmitOrder(selectedId);
                  //handleOrderSelect(selectedId);
                }} 

                  >
                    Submit Selected Order
                  </Button>
                </div>
              </div>
            {/* )} */}
          </div>
        </div></div>
        <div className="col-12 col-lg-4"></div>
      </div>


        {/* {selectedOrder && (
          <>
          <div className="shadow border p-4 mb-4" style={{ backgroundColor: "#f8f9fa" }}>

          <div className="order-summary my-3 px-4">
  <h6 className="mb-3" style={{fontSize: "17px"}}>Order Details:</h6>
  <div className="container-fluid">
    <div className="row">
     
      <div className="col-md-4" >
        <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "110px", marginRight: "10px" }}>Order Number:</span>
          <strong   style={{fontSize: "17px"}}>{selectedOrder.orderNumber}</strong>
        </div>
        <div className="d-flex"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "110px", marginRight: "10px"  }}>PO No.:</span>
          <strong   style={{fontSize: "17px"}}>{selectedOrder.poNumber}</strong>
        </div>
      </div>

     
      <div className="col-md-4">
       
         <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "130px", marginRight: "10px" }}>Order Entry Date:</span>
          <strong>{selectedOrder.entryDate}</strong>
        </div>
        <div className="d-flex "  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "130px", marginRight: "10px" }}>Customer:</span>
          <strong   style={{fontSize: "17px"}}>{selectedOrder.customerName}</strong>
        </div>
            
      </div>
        <div className="col-md-4">
        <div className="d-flex mb-3"  style={{fontSize: "17px"}}>
          <span style={{ minWidth: "130px", marginRight: "10px" ,fontSize: "17px" }}>PO Date:</span>
          <strong   style={{fontSize: "17px"}}>{selectedOrder.poDate}</strong>
        </div>
</div>
    </div>
  </div>
</div>
    
</div>
            
          </>
        )}
      </div>

      {selectedOrder && (
         <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
               <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
                 <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                   <div>
                     {/* <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                     <Select
                       defaultValue={pageSize}
                       onChange={handlePageSizeChange}
                       style={{ width: 120, textAlign: "center" }}
                     >
                       <Option value={10}>10</Option>
                       <Option value={20}>20</Option>
                       <Option value={30}>30</Option>
                     </Select> 
                   </div>
           
                   <div className="pt-4 pt-md-0">
                     <Input.Search
                       placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                       style={{ width: 200, marginBottom: 16 }}
                     />
                   </div>
                 </div>
           
                 <div style={{ backgroundColor: "white" }}>*/}
                   {/* <Table
                     bordered
                     style={{ padding: "0px 10px", overflowX: "auto" }}
                     columns={columns}
                     dataSource={filteredData}
                     pagination={{
                       pageSize: pageSize,
                       total: totalEntries,
                       showTotal: (total, range) =>
                         `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                       current: currentPage,
                       onChange: (page) => setCurrentPage(page),
                     }}
                     showSorterTooltip={false}
                     rowKey={(record) => record.id}
                     components={components}
                   /> */}
                  {/* <div style={{ overflowX: "auto" }}>
                   <DataTable
  columns={columns}
  data={filteredData}
  pagination
  paginationPerPage={pageSize}
  paginationTotalRows={totalEntries}
  paginationServer
  paginationComponentOptions={{
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: true,
  }}
  onChangePage={(page) => setCurrentPage(page)}
  customStyles={customStyles}
  persistTableHead
  highlightOnHover
  striped
/>
{isBulkSelecting && approvedItems.size > 1 && (
  <div className="text-center px-md-5 mb-3" style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
    <Button
      onClick={handleBulkApprove}
      style={{
        backgroundColor: buttonColor,
        borderColor: buttonColor,
        color: "#fff",
      }}
    >
      {buttonText}
    </Button>
    
    <Button
      onClick={updateRates}
      style={{
        backgroundColor: "#28a745",
        borderColor: "#28a745",
        color: "#fff",
      }}
    >
      Bulk Update Rates
    </Button>
  </div>
)}
</div>
                 </div>

      
         
               </div>
               <div className="text-center pt-3">
              <Button
                 type="submit"
                className="CancelBtn mx-1"
                onClick={() => {
                  setSelectedOrder(null);
                  setOrderItems([]);
                  setApprovedItems(new Set());
                  fetchRateSheetData();
                }}
              >
              Back to Page 
              </Button>
            </div>
             </div>
      )} */}
    </div>
    </div>
    </div>
    </div>
    </div>
  );

};
export default RateApproval